import { dataTextSquareSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconTextSquareSolid = /*#__PURE__*/createIcon(dataTextSquareSolid)
export default IconTextSquareSolid
